export default "__VITE_ASSET__CVYpS2gc__"